import React from "react";
export default function getSVG(type, color) {
	switch (type) {
		case "chat-active":
			return (
				<svg
					width="73"
					height="81"
					viewBox="0 10 73 81"
					fill="none">
					<g filter="url(#filter0_d)">
						<path
							d="M53 54L52.1865 54.9491L54.25 56.7178L54.25 54L53 54ZM44.8333 47L45.6468 46.0509L45.2957 45.75L44.8333 45.75L44.8333 47ZM53 42L51.75 42L53 42ZM53 19L54.25 19L53 19ZM20 19L21.25 19L20 19ZM20 42L18.75 42L20 42ZM25 47L25 48.25L25 47ZM53.8135 53.0509L45.6468 46.0509L44.0198 47.9491L52.1865 54.9491L53.8135 53.0509ZM51.75 42L51.75 54L54.25 54L54.25 42L51.75 42ZM51.75 19L51.75 42L54.25 42L54.25 19L51.75 19ZM48 15.25C50.0711 15.25 51.75 16.9289 51.75 19L54.25 19C54.25 15.5482 51.4518 12.75 48 12.75L48 15.25ZM25 15.25L48 15.25L48 12.75L25 12.75L25 15.25ZM21.25 19C21.25 16.9289 22.9289 15.25 25 15.25L25 12.75C21.5482 12.75 18.75 15.5482 18.75 19L21.25 19ZM21.25 42L21.25 19L18.75 19L18.75 42L21.25 42ZM25 45.75C22.9289 45.75 21.25 44.0711 21.25 42L18.75 42C18.75 45.4518 21.5482 48.25 25 48.25L25 45.75ZM44.8333 45.75L25 45.75L25 48.25L44.8333 48.25L44.8333 45.75Z"
							fill={color ? color : "#1C4E80"}
						/>
					</g>
					<path
						d="M26 36C29.3333 39.0185 38 43.2444 46 36"
						stroke={color ? color : "#1C4E80"}
						stroke-width="2.5"
						stroke-linecap="round"
					/>
					<defs>
						<filter
							id="filter0_d"
							x="0.75"
							y="0.75"
							width="71.5"
							height="79.9678"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB">
							<feFlood
								flood-opacity="0"
								result="BackgroundImageFix"
							/>
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="6" />
							<feGaussianBlur stdDeviation="9" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow"
								result="shape"
							/>
						</filter>
					</defs>
				</svg>
			);

		case "chat-inactive":
			return (
				<svg
					width="73"
					height="81"
					viewBox="0 10 73 81"
					fill="none">
					<g filter="url(#filter0_d)">
						<path
							d="M53 54L52.1865 54.9491L54.25 56.7178L54.25 54L53 54ZM44.8333 47L45.6468 46.0509L45.2957 45.75L44.8333 45.75L44.8333 47ZM53 42L51.75 42L53 42ZM53 19L54.25 19L53 19ZM20 19L21.25 19L20 19ZM20 42L18.75 42L20 42ZM25 47L25 48.25L25 47ZM53.8135 53.0509L45.6468 46.0509L44.0198 47.9491L52.1865 54.9491L53.8135 53.0509ZM51.75 42L51.75 54L54.25 54L54.25 42L51.75 42ZM51.75 19L51.75 42L54.25 42L54.25 19L51.75 19ZM48 15.25C50.0711 15.25 51.75 16.9289 51.75 19L54.25 19C54.25 15.5482 51.4518 12.75 48 12.75L48 15.25ZM25 15.25L48 15.25L48 12.75L25 12.75L25 15.25ZM21.25 19C21.25 16.9289 22.9289 15.25 25 15.25L25 12.75C21.5482 12.75 18.75 15.5482 18.75 19L21.25 19ZM21.25 42L21.25 19L18.75 19L18.75 42L21.25 42ZM25 45.75C22.9289 45.75 21.25 44.0711 21.25 42L18.75 42C18.75 45.4518 21.5482 48.25 25 48.25L25 45.75ZM44.8333 45.75L25 45.75L25 48.25L44.8333 48.25L44.8333 45.75Z"
							fill="#9D9D9D"
						/>
					</g>
					<path
						d="M26 36C29.3333 39.0185 38 43.2444 46 36"
						stroke="#9D9D9D"
						stroke-width="2.5"
						stroke-linecap="round"
					/>
					<path
						d="M17 17L55 50"
						stroke="white"
						stroke-width="2.5"
						stroke-linecap="round"
					/>
					<path
						d="M18 15L56 48"
						stroke="#9D9D9D"
						stroke-width="2.5"
						stroke-linecap="round"
					/>
					<defs>
						<filter
							id="filter0_d"
							x="0.75"
							y="0.75"
							width="71.5"
							height="79.9678"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB">
							<feFlood
								flood-opacity="0"
								result="BackgroundImageFix"
							/>
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="6" />
							<feGaussianBlur stdDeviation="9" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow"
								result="shape"
							/>
						</filter>
					</defs>
				</svg>
			);
		case "notification-active":
			return (
				<svg
					width="20"
					height="43"
					viewBox="0 0 37 43"
					fill="none">
					<path
						d="M34.7677 30.7558L33.118 28.2812C30.4784 24.3219 29.1586 19.5376 29.1586 14.7534C29.1586 9.63925 25.8591 5.34994 21.4049 4.03015C20.9099 2.71036 19.5902 1.8855 18.2704 1.8855C16.9506 1.8855 15.6308 2.71036 15.1359 4.03015C10.6816 5.34994 7.38213 9.63925 7.38213 14.7534C7.38213 19.5376 6.06235 24.3219 3.42277 28.2812L1.77304 30.7558C1.11315 31.9106 1.77304 33.2304 3.09283 33.2304H33.2829C34.6027 33.2304 35.4276 31.7457 34.7677 30.7558Z"
						stroke={color ? color : "#1C4E80"}
						stroke-width="2.5"
						stroke-miterlimit="10"
						stroke-linejoin="round"
					/>
					<path
						d="M23.2194 36.4614C23.2194 39.266 21.0748 41.4106 18.2702 41.4106C15.4657 41.4106 13.321 39.266 13.321 36.4614"
						stroke={color ? color : "#1C4E80"}
						stroke-width="2.5"
						stroke-miterlimit="10"
						stroke-linejoin="round"
					/>
				</svg>
			);

		case "arrow-up":
			return (
				<svg
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="2.5"
					stroke="currentColor"
					class="w-6 h-6">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
					/>
				</svg>
			);
		case "arrow-down":
			return (
				<svg
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="2.5"
					stroke="currentColor"
					class="w-6 h-6">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
					/>
				</svg>
			);

		case "close-icon":
			return (
				<svg
					fill={color ? color : "#000000"}
					viewBox="0 0 26 26">
					<path d="M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z" />
				</svg>
			);
		case "close-thin":
			return (
				<svg
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			);
		case "expand-controls-list":
			return (
				<svg
					viewBox="0 0 20 20"
					fill={color ? color : "#000"}
					class="text-[#344054] group-focus:text-blue-primary">
					<path
						d="M6.66667 5H17.5M6.66667 10H17.5M6.66667 15H17.5M2.5 5H2.50833M2.5 10H2.50833M2.5 15H2.50833"
						stroke="currentColor"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"></path>
				</svg>
			);
		case "expand-controls-headline":
			return (
				<svg
					viewBox="0 0 24 24"
					fill="none"
					class="text-[#344054] group-focus:text-blue-primary w-5 h-5">
					<path
						d="M21 10H3M21 6H3M21 14H3M21 18H3"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"></path>
				</svg>
			);
		case "double-arrow-down":
			return (
				<svg
					class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-zjt8k"
					focusable="false"
					aria-hidden="true"
					viewBox="0 0 24 24"
					data-testid="KeyboardDoubleArrowDownIcon"
					tabindex="-1"
					title="KeyboardDoubleArrowDown">
					<path d="M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"></path>
					<path d="m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"></path>
				</svg>
			);
		case "double-arrow-up":
			return (
				<svg
					class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-zjt8k"
					focusable="false"
					aria-hidden="true"
					viewBox="0 0 24 24"
					data-testid="KeyboardDoubleArrowUpIcon"
					tabindex="-1"
					title="KeyboardDoubleArrowUp">
					<path d="M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path>
					<path d="m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path>
				</svg>
			);
		// case 'normal-arrow-down' :
		//   return (

		//   )
		case "parent":
			return (
				<svg
					width="28px"
					height="28px"
					viewBox="0 0 24 24"
					version="1.1">
					<title>location_2_fill</title>
					<g
						id="页面-1"
						stroke="none"
						stroke-width="1"
						fill="none"
						fill-rule="evenodd">
						<g id="location_2_fill">
							<path
								d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
								id="MingCute"
								fill-rule="nonzero"></path>
							<path
								d="M6.72009,16.6398 C7.25029,16.4853 7.80543,16.7897 7.96003,17.32 C8.11462,17.8502 7.81012,18.4053 7.27991,18.5599 C6.77914,18.7059 6.41926,18.8607 6.18866,18.9996 C6.42735,19.1433 6.80251,19.303 7.32497,19.4523 C8.47958,19.7822 10.1328,19.9996 12,19.9996 C13.8672,19.9996 15.5204,19.7822 16.675,19.4523 C17.1975,19.303 17.5726,19.1433 17.8113,18.9996 C17.5807,18.8607 17.2209,18.7059 16.7201,18.5599 C16.1899,18.4053 15.8854,17.8502 16.04,17.32 C16.1946,16.7897 16.7497,16.4853 17.2799,16.6398 C17.948,16.8346 18.5608,17.0847 19.0293,17.4058 C19.4655,17.7048 20,18.2259 20,18.9996 C20,19.7832 19.4522,20.3078 19.0097,20.6067 C18.5322,20.9292 17.9071,21.1803 17.2245,21.3753 C15.8456,21.7693 13.9988,21.9996 12,21.9996 C10.0012,21.9996 8.15442,21.7693 6.77553,21.3753 C6.09289,21.1803 5.46776,20.9292 4.99033,20.6067 C4.54781,20.3078 4,19.7832 4,18.9996 C4,18.2259 4.53454,17.7048 4.97068,17.4058 C5.43918,17.0847 6.05202,16.8346 6.72009,16.6398 Z M12,2 C16.1421,2 19.5,5.35786 19.5,9.5 C19.5,12.0679 18.1005,14.1564 16.6502,15.6391 C16.0352526,16.2678158 15.3907163,16.8089881 14.7970227,17.2550925 C14.2033291,17.7011969 12.8455,18.5365 12.8455,18.5365 C12.3176,18.8347 11.6824,18.8347 11.1545,18.5365 C10.6266,18.2383 9.79665913,17.7011969 9.20296073,17.2550925 C8.60926233,16.8089881 7.96472316,16.2678158 7.34978,15.6391 C5.89953,14.1564 4.5,12.0679 4.5,9.5 C4.5,5.35786 7.85786,2 12,2 Z M12,7.5 C10.8954,7.5 10,8.39543 10,9.5 C10,10.6046 10.8954,11.5 12,11.5 C13.1046,11.5 14,10.6046 14,9.5 C14,8.39543 13.1046,7.5 12,7.5 Z"
								id="形状"
								fill="#09244B"
								fill-rule="nonzero"></path>
						</g>
					</g>
				</svg>
			);
		case "pencil-edit":
			return (
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="edit"
					width="1em"
					height="1em"
					fill="currentColor"
					aria-hidden="true">
					<path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path>
				</svg>
			);
		case "Profiles":
			return (
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="profile"
					fill="currentColor"
					aria-hidden="true">
					<path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z"></path>
				</svg>
			);
		case "Portfolio":
			return (
				<svg
					viewBox="0 0 24 24"
					fill="currentColor"
					class="w-6 h-6">
					<path
						fill-rule="evenodd"
						d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
						clip-rule="evenodd"
					/>
					<path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
				</svg>
			);
		case "Domain Admin":
			return (
				<svg
					viewBox="0 0 24 24"
					fill="currentColor"
					class="w-6 h-6">
					<path
						fill-rule="evenodd"
						d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
						clip-rule="evenodd"
					/>
				</svg>
			);
		case "Pencil":
			return (
				<svg
					viewBox="0 0 24 24"
					fill="currentColor"
					class="w-6 h-6">
					<path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
				</svg>
			);
		case "Edit":
			return (
				<svg
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
					/>
				</svg>
			);
		case "Directory":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" />
				</svg>
			);
		case "Data Retrieval":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z" />
				</svg>
			);

		case "Fetcher Health":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M80-600v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v120h-80v-120H160v120H80Zm80 440q-33 0-56.5-23.5T80-240v-120h80v120h640v-120h80v120q0 33-23.5 56.5T800-160H160Zm240-120q11 0 21-5.5t15-16.5l124-248 44 88q5 11 15 16.5t21 5.5h240v-80H665l-69-138q-5-11-15-15.5t-21-4.5q-11 0-21 4.5T524-658L400-410l-44-88q-5-11-15-16.5t-21-5.5H80v80h215l69 138q5 11 15 16.5t21 5.5Zm80-200Z" />
				</svg>
			);
		case "Zomato":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-120q-117 0-198.5-81.5T200-400q0-94 55.5-168.5T401-669q-20-5-39-14.5T328-708q-33-33-42.5-78.5T281-879q47-5 92.5 4.5T452-832q23 23 33.5 52t13.5 61q13-31 31.5-58.5T572-828q11-11 28-11t28 11q11 11 11 28t-11 28q-22 22-39 48.5T564-667q88 28 142 101.5T760-400q0 117-81.5 198.5T480-120Zm0-80q83 0 141.5-58.5T680-400q0-83-58.5-141.5T480-600q-83 0-141.5 58.5T280-400q0 83 58.5 141.5T480-200Zm0-200Z" />
				</svg>
			);
		case "Domain Control":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M440-280h80l12-60q12-5 22.5-10.5T576-364l58 18 40-68-46-40q2-14 2-26t-2-26l46-40-40-68-58 18q-11-8-21.5-13.5T532-620l-12-60h-80l-12 60q-12 5-22.5 10.5T384-596l-58-18-40 68 46 40q-2 14-2 26t2 26l-46 40 40 68 58-18q11 8 21.5 13.5T428-340l12 60Zm40-120q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
				</svg>
			);
		case "Customization":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M120-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T360-790v84q-72 26-116 88.5T200-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H120Zm717-360h-81q-5-35-21.5-67T690-648l-10-10v98h-80v-240h240v80H730l16 14q41 42 63 89t28 97ZM680-40l-12-60q-12-5-22.5-10.5T624-124l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T668-380l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T772-100l-12 60h-80Zm40-120q33 0 56.5-23.5T800-240q0-33-23.5-56.5T720-320q-33 0-56.5 23.5T640-240q0 33 23.5 56.5T720-160Z" />
				</svg>
			);
		case "Tier Control":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M710-150q-63 0-106.5-43.5T560-300q0-63 43.5-106.5T710-450q63 0 106.5 43.5T860-300q0 63-43.5 106.5T710-150Zm0-80q29 0 49.5-20.5T780-300q0-29-20.5-49.5T710-370q-29 0-49.5 20.5T640-300q0 29 20.5 49.5T710-230Zm-550-30v-80h320v80H160Zm90-250q-63 0-106.5-43.5T100-660q0-63 43.5-106.5T250-810q63 0 106.5 43.5T400-660q0 63-43.5 106.5T250-510Zm0-80q29 0 49.5-20.5T320-660q0-29-20.5-49.5T250-730q-29 0-49.5 20.5T180-660q0 29 20.5 49.5T250-590Zm230-30v-80h320v80H480Zm230 320ZM250-660Z" />
				</svg>
			);
		case "Categories":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z" />
				</svg>
			);
		case "URL Look-Up":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M440-240q116 0 198-81.5T720-520q0-116-82-198t-198-82q-117 0-198.5 82T160-520q0 117 81.5 198.5T440-240Zm0-280Zm0 160q-83 0-147.5-44.5T200-520q28-70 92.5-115T440-680q82 0 146.5 45T680-520q-29 71-93.5 115.5T440-360Zm0-60q55 0 101-26.5t72-73.5q-26-46-72-73t-101-27q-56 0-102 27t-72 73q26 47 72 73.5T440-420Zm0-40q25 0 42.5-17t17.5-43q0-25-17.5-42.5T440-580q-26 0-43 17.5T380-520q0 26 17 43t43 17Zm0 300q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T80-520q0-74 28.5-139.5t77-114.5q48.5-49 114-77.5T440-880q74 0 139.5 28.5T694-774q49 49 77.5 114.5T800-520q0 64-21 121t-58 104l159 159-57 56-159-158q-47 37-104 57.5T440-160Z" />
				</svg>
			);
		case "Site Indexing":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M376-178q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm34-240h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Zm200 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm234 0h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 10-.5 20t-1.5 20h-81q2-10 2.5-19.5t.5-20.5q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480v20.5q0 9.5-1 19.5h-80q1-10 1-19.5V-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400h134v80H404q12 44 31 83t45 75q11-16 21-32.5t19-33.5v146q-10 1-19.5 1.5T480-80Zm318-25L680-223v89h-80v-226h226v80h-90l118 118-56 57Z" />
				</svg>
			);
		case "Account Sync Log":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z" />
				</svg>
			);
		case "Email Assets":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#e3e3e3">
					<path d="M160-240v-480 520-40Zm0 80q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v200h-80v-200H447l-80-80H160v480h200v80H160ZM584-56 440-200l144-144 56 57-87 87 87 87-56 57Zm192 0-56-57 87-87-87-87 56-57 144 144L776-56Z" />
				</svg>
			);
		case "Review Audit Log":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M280-120 80-320l200-200 57 56-104 104h607v80H233l104 104-57 56Zm400-320-57-56 104-104H120v-80h607L623-784l57-56 200 200-200 200Z" />
				</svg>
			);
		case "Restricted Domains":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" />
				</svg>
			);
		case "UpOutlined":
			return (
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="up"
					width="1em"
					height="1em"
					fill="currentColor"
					aria-hidden="true">
					<path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"></path>
				</svg>
			);
		case "DownOutlined":
			return (
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="down"
					width="1em"
					height="1em"
					fill="currentColor"
					aria-hidden="true">
					<path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
				</svg>
			);
		case "Add":
			return (
				<svg
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M12 4.5v15m7.5-7.5h-15"
					/>
				</svg>
			);
		case "dragg":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z" />
				</svg>
			);
		case "eye":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
				</svg>
			);
		case "fullScreen":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z" />
				</svg>
			);
		case "liveChat":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
				</svg>
			);
		case "fullScreen-exit":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M240-120v-120H120v-80h200v200h-80Zm400 0v-200h200v80H720v120h-80ZM120-640v-80h120v-120h80v200H120Zm520 0v-200h80v120h120v80H640Z" />
				</svg>
			);
		case "knowledgePanel":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
				</svg>
			);
		case "customNavigationLinks":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M120-840h320v320H120v-320Zm80 80v160-160Zm320-80h320v320H520v-320Zm80 80v160-160ZM120-440h320v320H120v-320Zm80 80v160-160Zm440-80h80v120h120v80H720v120h-80v-120H520v-80h120v-120Zm-40-320v160h160v-160H600Zm-400 0v160h160v-160H200Zm0 400v160h160v-160H200Z" />
				</svg>
			);
		case "featureRequests":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-200v-80h320v80H320Zm10-120q-69-41-109.5-110T180-580q0-125 87.5-212.5T480-880q125 0 212.5 87.5T780-580q0 81-40.5 150T630-320H330Zm24-80h252q45-32 69.5-79T700-580q0-92-64-156t-156-64q-92 0-156 64t-64 156q0 54 24.5 101t69.5 79Zm126 0Z" />
				</svg>
			);
		case "siteSearch":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M260-120q-58 0-99-41t-41-99q0-58 41-99t99-41h60v-160h-60q-58 0-99-41t-41-99q0-58 41-99t99-41q58 0 99 41t41 99v60h160v-60q0-58 41-99t99-41q58 0 99 41t41 99q0 58-41 99t-99 41h-60v160h60q58 0 99 41t41 99q0 58-41 99t-99 41q-58 0-99-41t-41-99v-60H400v60q0 58-41 99t-99 41Zm0-80q25 0 42.5-17.5T320-260v-60h-60q-25 0-42.5 17.5T200-260q0 25 17.5 42.5T260-200Zm440 0q25 0 42.5-17.5T760-260q0-25-17.5-42.5T700-320h-60v60q0 25 17.5 42.5T700-200ZM400-400h160v-160H400v160ZM260-640h60v-60q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm380 0h60q25 0 42.5-17.5T760-700q0-25-17.5-42.5T700-760q-25 0-42.5 17.5T640-700v60Z" />
				</svg>
			);
		case "platformAdmin":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M680-280q25 0 42.5-17.5T740-340q0-25-17.5-42.5T680-400q-25 0-42.5 17.5T620-340q0 25 17.5 42.5T680-280Zm0 120q31 0 57-14.5t42-38.5q-22-13-47-20t-52-7q-27 0-52 7t-47 20q16 24 42 38.5t57 14.5ZM480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v227q-19-8-39-14.5t-41-9.5v-147l-240-90-240 90v188q0 47 12.5 94t35 89.5Q310-290 342-254t71 60q11 32 29 61t41 52q-1 0-1.5.5t-1.5.5Zm200 0q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80ZM480-494Z" />
				</svg>
			);
		case "supportTickets":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80ZM364-182l48-110q-42-15-72.5-46.5T292-412l-110 46q23 64 71 112t111 72Zm-72-366q17-42 47.5-73.5T412-668l-46-110q-64 24-112 72t-72 112l110 46Zm188 188q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm116 178q63-24 110.5-71.5T778-364l-110-48q-15 42-46 72.5T550-292l46 110Zm72-368 110-46q-24-63-71.5-110.5T596-778l-46 112q41 15 71 45.5t47 70.5Z" />
				</svg>
			);
		case "latestUpdates":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z" />
				</svg>
			);
		case "productRoadMap":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M120-440v-320q0-33 23.5-56.5T200-840h240v400H120Zm240-80Zm160-320h240q33 0 56.5 23.5T840-760v160H520v-240Zm0 720v-400h320v320q0 33-23.5 56.5T760-120H520ZM120-360h320v240H200q-33 0-56.5-23.5T120-200v-160Zm240 80Zm240-400Zm0 240Zm-400-80h160v-240H200v240Zm400-160h160v-80H600v80Zm0 240v240h160v-240H600ZM200-280v80h160v-80H200Z" />
				</svg>
			);
		case "training":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-118 120-398l66-50 294 228 294-228 66 50-360 280Zm0-202L120-600l360-280 360 280-360 280Zm0-280Zm0 178 230-178-230-178-230 178 230 178Z" />
				</svg>
			);
		case "translate":
		case "Translations":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m476-80 182-480h84L924-80h-84l-42-122H604L560-80h-84Zm152-192h144l-70-198h-4l-70 198Zm-468 72-56-56 202-202q-38-42-66.5-87T190-640h84q18 36 38.5 65t49.5 61q44-48 73-98.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 71-57 138t-89 126l96 98-30 82-124-124-200 200Z" />
				</svg>
			);
		case "plus":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
				</svg>
			);
		case "lens":
			return (
				<svg
					viewBox="0 -0.24 28.423 28.423"
					data-name="02 - Search Button"
					color="#999">
					<path
						id="Path_215"
						data-name="Path 215"
						d="M14.953,2.547A12.643,12.643,0,1,0,27.6,15.19,12.649,12.649,0,0,0,14.953,2.547Zm0,2A10.643,10.643,0,1,1,4.31,15.19,10.648,10.648,0,0,1,14.953,4.547Z"
						transform="translate(-2.31 -2.547)"
						fillRule="evenodd"
					/>{" "}
					<path
						id="Path_216"
						data-name="Path 216"
						d="M30.441,28.789l-6.276-6.276a1,1,0,1,0-1.414,1.414L29.027,30.2a1,1,0,1,0,1.414-1.414Z"
						transform="translate(-2.31 -2.547)"
						fillRule="evenodd"
					/>
				</svg>
			);
		case "workspace":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M240-120q-66 0-113-47T80-280q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm480 0q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm-480-80q33 0 56.5-23.5T320-280q0-33-23.5-56.5T240-360q-33 0-56.5 23.5T160-280q0 33 23.5 56.5T240-200Zm480 0q33 0 56.5-23.5T800-280q0-33-23.5-56.5T720-360q-33 0-56.5 23.5T640-280q0 33 23.5 56.5T720-200ZM480-520q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T560-680q0-33-23.5-56.5T480-760q-33 0-56.5 23.5T400-680q0 33 23.5 56.5T480-600Zm0-80Zm240 400Zm-480 0Z" />
				</svg>
			);
		case "square-edit":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
				</svg>
			);
		case "home":
			return (
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="home"
					fill="currentColor"
					aria-hidden="true">
					<path d="M946.5 505L534.6 93.4a31.93 31.93 0 00-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z"></path>
				</svg>
			);
		case "draft":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m480-920 362 216q18 11 28 30t10 40v434q0 33-23.5 56.5T800-120H160q-33 0-56.5-23.5T80-200v-434q0-21 10-40t28-30l362-216Zm0 466 312-186-312-186-312 186 312 186Zm0 94L160-552v352h640v-352L480-360Zm0 160h320-640 320Z" />
				</svg>
			);
		case "Pub/Sub":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M160-400q-33 0-56.5-23.5T80-480q0-33 23.5-56.5T160-560q33 0 56.5 23.5T240-480q0 33-23.5 56.5T160-400Zm66 228-56-56 174-174 56 56-174 174Zm120-388L172-734l56-56 174 174-56 56ZM480-80q-33 0-56.5-23.5T400-160q0-33 23.5-56.5T480-240q33 0 56.5 23.5T560-160q0 33-23.5 56.5T480-80Zm0-640q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720Zm134 162-56-58 176-174 56 56-176 176Zm120 386L560-346l56-56 174 174-56 56Zm66-228q-33 0-56.5-23.5T720-480q0-33 23.5-56.5T800-560q33 0 56.5 23.5T880-480q0 33-23.5 56.5T800-400Z" />
				</svg>
			);
		case "settings":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z" />
				</svg>
			);
		case "expand":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M400-280v-400l200 200-200 200Z" />
				</svg>
			);
		case "hint":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-120q-33 0-56.5-23.5T400-200q0-33 23.5-56.5T480-280q33 0 56.5 23.5T560-200q0 33-23.5 56.5T480-120Zm-80-240v-480h160v480H400Z" />
				</svg>
			);
		case "info":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
				</svg>
			);
		case "check-box":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
				</svg>
			);
		case "square-edit":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
				</svg>
			);
		case "delete-box":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
				</svg>
			);
		case "download-icon":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
				</svg>
			);
		case "Integration Monitor":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M220-80q-58 0-99-41t-41-99q0-58 41-99t99-41q18 0 35 4.5t32 12.5l153-153v-110q-44-13-72-49.5T340-740q0-58 41-99t99-41q58 0 99 41t41 99q0 48-28 84.5T520-606v110l154 153q15-8 31.5-12.5T740-360q58 0 99 41t41 99q0 58-41 99t-99 41q-58 0-99-41t-41-99q0-18 4.5-35t12.5-32L480-424 343-287q8 15 12.5 32t4.5 35q0 58-41 99t-99 41Zm520-80q25 0 42.5-17.5T800-220q0-25-17.5-42.5T740-280q-25 0-42.5 17.5T680-220q0 25 17.5 42.5T740-160ZM480-680q25 0 42.5-17.5T540-740q0-25-17.5-42.5T480-800q-25 0-42.5 17.5T420-740q0 25 17.5 42.5T480-680ZM220-160q25 0 42.5-17.5T280-220q0-25-17.5-42.5T220-280q-25 0-42.5 17.5T160-220q0 25 17.5 42.5T220-160Z" />
				</svg>
			);
		case "Super Admins":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M680-119q-8 0-16-2t-15-7l-120-70q-14-8-21.5-21.5T500-249v-141q0-16 7.5-29.5T529-441l120-70q7-5 15-7t16-2q8 0 15.5 2.5T710-511l120 70q14 8 22 21.5t8 29.5v141q0 16-8 29.5T830-198l-120 70q-7 4-14.5 6.5T680-119ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5H80Zm320-400q33 0 56.5-23.5T480-640q0-33-23.5-56.5T400-720q-33 0-56.5 23.5T320-640q0 33 23.5 56.5T400-560Zm0-80Zm12 400Zm174-166 94 55 94-55-94-54-94 54Zm124 208 90-52v-110l-90 53v109Zm-150-52 90 53v-109l-90-53v109Z" />
				</svg>
			);
		case "user-management":
			return (
				<svg
					width="24"
					height="24"
					viewBox="0 -960 960 960"
					fill="currentColor">
					<path d="M680-119q-8 0-16-2t-15-7l-120-70q-14-8-21.5-21.5T500-249v-141q0-16 7.5-29.5T529-441l120-70q7-4 15-6.5t16-2.5q8 0 16 2.5t15 6.5l120 70q14 8 22 21.5t8 29.5v141q0 16-8 29.5T830-198l-120 70q-7 5-15 7t-16 2ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5H80Z" />
				</svg>
			);
		case "Email Delivery":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-160q-33 0-56.5-23.5T120-240v-560q0-33 23.5-56.5T200-880h560q33 0 56.5 23.5T840-800v226q-19-9-39-14.5t-41-8.5v-203H200v360h168q9 27 30 47t47 28q-3 20-4 40.5t2 40.5q-36-7-67.5-26.5T320-360H200v120h253q7 22 16 42t22 38H200Zm0-80h253-253Zm481 120-12-60q-12-5-22.5-10.5T625-204l-58 18-40-68 46-40q-2-12-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T669-460l12-60h80l12 60q12 5 22.5 10.5T817-436l58-18 40 68-46 40q2 12 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T773-180l-12 60h-80Zm40-120q33 0 56.5-23.5T801-320q0-33-23.5-56.5T721-400q-33 0-56.5 23.5T641-320q0 33 23.5 56.5T721-240Z" />
				</svg>
			);
		case "Walmart Audit":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="undefined">
					<path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm491-80h69v-69l-69 69Zm-457 0h73l120-120h85L392-200h64l120-120h85L541-200h65l120-120h34v-440H200v509l69-69h85L234-200Zm72-200-56-56 177-177 80 80 147-147 56 56-203 204-80-80-121 120ZM200-200v-560 560Z" />
				</svg>
			);
		case "location-on":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
				</svg>
			);
		case "listing":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M160-720v-80h640v80H160Zm0 560v-240h-40v-80l40-200h640l40 200v80h-40v240h-80v-240H560v240H160Zm80-80h240v-160H240v160Zm-38-240h556-556Zm0 0h556l-24-120H226l-24 120Z" />
				</svg>
			);
		case "department":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M360-240v-80h480v80H360Zm0-200v-80h480v80H360ZM120-640v-80h720v80H120Z" />
				</svg>
			);
		case "core":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M680-320q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T720-440q0-17-11.5-28.5T680-480q-17 0-28.5 11.5T640-440q0 17 11.5 28.5T680-400ZM440-40v-116q0-21 10-39.5t28-29.5q32-19 67.5-31.5T618-275l62 75 62-75q37 6 72 18.5t67 31.5q18 11 28.5 29.5T920-156v116H440Zm79-80h123l-54-66q-18 5-35 13t-34 17v36Zm199 0h122v-36q-16-10-33-17.5T772-186l-54 66Zm-76 0Zm76 0Zm-518 0q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v200q-16-20-35-38t-45-24v-138H200v560h166q-3 11-4.5 22t-1.5 22v36H200Zm80-480h280q26-20 57-30t63-10v-40H280v80Zm0 160h200q0-21 4.5-41t12.5-39H280v80Zm0 160h138q11-9 23.5-16t25.5-13v-51H280v80Zm-80 80v-560 137-17 440Zm480-240Z" />
				</svg>
			);
		case "sales-executive":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-246q54-53 125.5-83.5T480-360q83 0 154.5 30.5T760-246v-514H200v514Zm280-194q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm80-80h400v-10q-42-35-93-52.5T480-280q-56 0-107 17.5T280-210v10Zm200-320q-25 0-42.5-17.5T420-580q0-25 17.5-42.5T480-640q25 0 42.5 17.5T540-580q0 25-17.5 42.5T480-520Zm0 17Z" />
				</svg>
			);
		case "client-success":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M640-400q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM400-160v-76q0-21 10-40t28-30q45-27 95.5-40.5T640-360q56 0 106.5 13.5T842-306q18 11 28 30t10 40v76H400Zm86-80h308q-35-20-74-30t-80-10q-41 0-80 10t-74 30Zm154-240q17 0 28.5-11.5T680-520q0-17-11.5-28.5T640-560q-17 0-28.5 11.5T600-520q0 17 11.5 28.5T640-480Zm0-40Zm0 280ZM120-400v-80h320v80H120Zm0-320v-80h480v80H120Zm324 160H120v-80h360q-14 17-22.5 37T444-560Z" />
				</svg>
			);
		case "swap-vert":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z" />
				</svg>
			);
		case "time-line":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-120q-138 0-240.5-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z" />
				</svg>
			);
		case "calendar-month":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
				</svg>
			);
		case "draft-order":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93ZM320-320v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T663-540L443-320H320Zm300-263-37-37 37 37ZM380-380h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
				</svg>
			);
		case "receipt":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M120-80v-800l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v800l-60-60-60 60-60-60-60 60-60-60-60 60-60-60-60 60-60-60-60 60-60-60-60 60Zm120-200h480v-80H240v80Zm0-160h480v-80H240v80Zm0-160h480v-80H240v80Zm-40 404h560v-568H200v568Zm0-568v568-568Z" />
				</svg>
			);
		case "check-icon":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
				</svg>
			);
		case "auto-motion":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-80q-33 0-56.5-23.5T400-160v-320q0-33 23.5-56.5T480-560h320q33 0 56.5 23.5T880-480v320q0 33-23.5 56.5T800-80H480Zm0-80h320v-320H480v320Zm-240-80v-400q0-33 23.5-56.5T320-720h400v80H320v400h-80ZM80-400v-400q0-33 23.5-56.5T160-880h400v80H160v400H80Zm400 240v-320 320Z" />
				</svg>
			);
		case "for-you":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-480q81 0 169-16.5T800-540v400q-60 27-146 43.5T480-80q-88 0-174-16.5T160-140v-400q63 27 151 43.5T480-480Zm240 280v-230q-50 14-115.5 22T480-400q-59 0-124.5-8T240-430v230q50 18 115 29t125 11q60 0 125-11t115-29ZM480-880q66 0 113 47t47 113q0 66-47 113t-113 47q-66 0-113-47t-47-113q0-66 47-113t113-47Zm0 240q33 0 56.5-23.5T560-720q0-33-23.5-56.5T480-800q-33 0-56.5 23.5T400-720q0 33 23.5 56.5T480-640Zm0-80Zm0 425Z" />
				</svg>
			);
		case "auto-stories":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-160q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740v484q51-32 107-48t113-16q36 0 70.5 6t69.5 18v-480q15 5 29.5 10.5T898-752q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59Zm80-200v-380l200-200v400L560-360Zm-160 65v-396q-33-14-68.5-21.5T260-720q-37 0-72 7t-68 21v397q35-13 69.5-19t70.5-6q36 0 70.5 6t69.5 19Zm0 0v-396 396Z" />
				</svg>
			);
		case "bookmark-check":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m438-400 198-198-57-56-141 141-57-57-57 57 114 113ZM200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Zm80-122 200-86 200 86v-518H280v518Zm0-518h400-400Z" />
				</svg>
			);
		case "star":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="m233-120 65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
				</svg>
			);
		case "hour-glass":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120Zm160-360q66 0 113-47t47-113v-120H320v120q0 66 47 113t113 47ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h80v80H160Zm320-80Zm0-640Z" />
				</svg>
			);
		case "globe-clock":
			return (
				<svg viewBox="0 0 24 24">
					<path
						d="M22.0031 12.0016C22.0031 6.47785 17.5253 2 12.0016 2C6.47785 2 2 6.47785 2 12.0016C2 17.5253 6.47785 22.0031 12.0016 22.0031C12.2648 22.0031 12.5256 21.9929 12.7835 21.9726C12.361 21.5273 12.0009 21.0221 11.7176 20.4713C10.6648 20.2363 9.66105 18.7168 9.06265 16.5013L11.0763 16.5011C11.157 15.978 11.3 15.4755 11.4976 15.0014L8.73973 15.0016C8.58615 14.0714 8.5 13.0611 8.5 12.0016C8.5 11.3109 8.5366 10.6412 8.60462 10.001H15.3985C15.4437 10.427 15.4751 10.866 15.4897 11.3168C15.965 11.1624 16.4643 11.0613 16.9806 11.0213C16.9647 10.676 16.9404 10.3355 16.9081 10.0009L20.2516 10.001L20.2662 10.0001C20.3901 10.5135 20.4674 11.0452 20.4933 11.5903L20.501 11.908L20.4971 11.7307C21.038 12.0122 21.5343 12.3676 21.973 12.7837C21.9929 12.5256 22.0031 12.2648 22.0031 12.0016ZM4.78738 16.5017L7.50986 16.5018C7.83363 17.8356 8.30124 19.0014 8.88154 19.9123C7.17916 19.2404 5.74572 18.0348 4.78738 16.5017ZM3.73261 10.0181L3.73737 10.0009L3.75155 10.001L7.09497 10.0009C7.03246 10.6483 7 11.3175 7 12.0016C7 13.0442 7.07543 14.0524 7.21773 15.0015L4.04457 15.0019C3.69259 14.0689 3.5 13.0577 3.5 12.0016C3.5 11.3186 3.58053 10.6545 3.73261 10.0181ZM8.8597 4.09942L8.8826 4.0907C8.16002 5.22295 7.61317 6.74888 7.29982 8.50167L4.2517 8.5013C5.15637 6.50144 6.81238 4.91413 8.8597 4.09942ZM11.8859 3.5053L12.0016 3.5C13.3076 3.5 14.5878 5.53542 15.1728 8.50125H8.83026C9.39798 5.62302 10.6205 3.62106 11.8859 3.5053ZM15.2284 4.26486L15.1216 4.09076C17.1789 4.90285 18.8435 6.49433 19.7514 8.5013L16.7033 8.50167C16.4057 6.83721 15.8976 5.37732 15.2284 4.26486Z"
						fill="#212121"
					/>
					<path
						d="M23 17.5C23 14.4624 20.5376 12 17.5 12C14.4624 12 12 14.4624 12 17.5C12 20.5376 14.4624 23 17.5 23C20.5376 23 23 20.5376 23 17.5ZM17.5 17.5H19.5C19.7761 17.5 20 17.7239 20 18C20 18.2762 19.7761 18.5 19.5 18.5H17C16.7268 18.5 16.5048 18.2809 16.5001 18.0089L16.5 17.9999V14.9999C16.5 14.7238 16.7239 14.4999 17 14.4999C17.2761 14.4999 17.5 14.7238 17.5 14.9999L17.5 17.5Z"
						fill="#212121"
					/>
				</svg>
			);
		case "bookmark":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Zm80-122 200-86 200 86v-518H280v518Zm0-518h400-400Z" />
				</svg>
			);
		case "bookmark-selected":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z" />
				</svg>
			);
		case "error-icon":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
				</svg>
			);
		case "language":
			return (
				<svg viewBox="0 -960 960 960">
					<path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" />
				</svg>
			);
		case "temprature":
			return (
				<svg
					viewBox="0 0 24 24"
					stroke="#bdbdbd">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
					/>
				</svg>
			);
		case "edit-pencil":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 -960 960 960">
					<path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
				</svg>
			);
		case "facebook-icon":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="#1877F2"
					width="48px"
					height="48px">
					<path d="M22,12C22,6.48,17.52,2,12,2S2,6.48,2,12c0,4.84,3.68,8.84,8.44,9.78v-6.91h-2.54v-2.87h2.54V9.59c0-2.5,1.52-3.87,3.74-3.87c1.06,0,2.19,0.19,2.19,0.19v2.41h-1.23c-1.21,0-1.59,0.75-1.59,1.52v1.82h2.72l-0.43,2.87h-2.29v6.91C18.32,20.84,22,16.84,22,12z" />
				</svg>
			);
		case "youtube-icon":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="#FF0000"
					width="48px"
					height="48px">
					<path d="M23.5,6.9c0-1.5-1.2-2.7-2.7-2.8C18.4,4,12,4,12,4s-6.4,0-8.8,0.1c-1.5,0.1-2.7,1.3-2.7,2.8C0.4,8.9,0,11.2,0,12.5c0,1.3,0.4,3.6,0.5,5.5c0,1.5,1.2,2.7,2.7,2.8c2.4,0.1,8.8,0.1,8.8,0.1s6.4,0,8.8-0.1c1.5-0.1,2.7-1.3,2.7-2.8c0.1-1.9,0.5-4.2,0.5-5.5C24,11.2,23.5,8.9,23.5,6.9z M9.8,15.6v-7.2L15.6,12L9.8,15.6z" />
				</svg>
			);
		case "twitter-icon":
			return (
				<svg
					fill-rule="evenodd"
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="x"
					width="1em"
					height="1em"
					fill="black"
					aria-hidden="true">
					<path d="M921 912L601.11 445.75l.55.43L890.08 112H793.7L558.74 384 372.15 112H119.37l298.65 435.31-.04-.04L103 912h96.39L460.6 609.38 668.2 912zM333.96 184.73l448.83 654.54H706.4L257.2 184.73z"></path>
				</svg>
			);
		case "insta-icon":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					width="48px"
					height="48px">
					<defs>
						<linearGradient
							id="instagram-gradient"
							x1="0%"
							y1="0%"
							x2="100%"
							y2="100%">
							<stop
								offset="0%"
								stop-color="#f09433"
							/>
							<stop
								offset="25%"
								stop-color="#e6683c"
							/>
							<stop
								offset="50%"
								stop-color="#dc2743"
							/>
							<stop
								offset="75%"
								stop-color="#cc2366"
							/>
							<stop
								offset="100%"
								stop-color="#bc1888"
							/>
						</linearGradient>
					</defs>
					<path
						d="M12 2.2c2.9 0 3.3 0 4.5.1 1.2.1 2 .2 2.6.4.6.2 1.1.5 1.6 1 .5.5.8 1 .9 1.6.2.6.3 1.3.4 2.6.1 1.2.1 1.6.1 4.5s0 3.3-.1 4.5c-.1 1.2-.2 2-.4 2.6-.2.6-.5 1.1-1 1.6-.5.5-1 .8-1.6.9-.6.2-1.3.3-2.6.4-1.2.1-1.6.1-4.5.1s-3.3 0-4.5-.1c-1.2-.1-2-.2-2.6-.4-.6-.2-1.1-.5-1.6-1-.5-.5-.8-1-.9-1.6-.2-.6-.3-1.3-.4-2.6-.1-1.2-.1-1.6-.1-4.5s0-3.3.1-4.5c.1-1.2.2-2 .4-2.6.2-.6.5-1.1 1-1.6.5-.5 1-.8 1.6-.9.6-.2 1.3-.3 2.6-.4 1.2-.1 1.6-.1 4.5-.1zm0 1.8c-2.8 0-3.2 0-4.4.1-1.1.1-1.7.2-2.1.3-.5.1-.8.3-1.1.6-.3.3-.5.6-.6 1.1-.1.4-.3 1-.3 2.1-.1 1.1-.1 1.5-.1 4.4s0 3.2.1 4.4c.1 1.1.2 1.7.3 2.1.1.5.3.8.6 1.1.3.3.6.5 1.1.6.4.1 1 .3 2.1.3 1.1.1 1.5.1 4.4.1s3.2 0 4.4-.1c1.1-.1 1.7-.2 2.1-.3.5-.1.8-.3 1.1-.6.3-.3.5-.6.6-1.1.1-.4.3-1 .3-2.1.1-1.1.1-1.5.1-4.4s0-3.2-.1-4.4c-.1-1.1-.2-1.7-.3-2.1-.1-.5-.3-.8-.6-1.1-.3-.3-.6-.5-1.1-.6-.4-.1-1-.3-2.1-.3-1.1-.1-1.5-.1-4.4-.1zm0 4.4a5.4 5.4 0 110 10.8 5.4 5.4 0 010-10.8zm0 1.8a3.6 3.6 0 100 7.2 3.6 3.6 0 000-7.2zm5.6-2.2a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
						fill="url(#instagram-gradient)"
					/>
				</svg>
			);
		case "pinterest-icon":
			return (
				<svg
					fill-rule="evenodd"
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="pinterest"
					width="1em"
					height="1em"
					fill="rgb(230 0 35)"
					aria-hidden="true">
					<path d="M512 64C264.97 64 64 264.97 64 512c0 192.53 122.08 357.04 292.88 420.28-4.92-43.86-4.14-115.68 3.97-150.46 7.6-32.66 49.11-208.16 49.11-208.16s-12.53-25.1-12.53-62.16c0-58.24 33.74-101.7 75.77-101.7 35.74 0 52.97 26.83 52.97 58.98 0 35.96-22.85 89.66-34.7 139.43-9.87 41.7 20.91 75.7 62.02 75.7 74.43 0 131.64-78.5 131.64-191.77 0-100.27-72.03-170.38-174.9-170.38-119.15 0-189.08 89.38-189.08 181.75 0 35.98 13.85 74.58 31.16 95.58 3.42 4.16 3.92 7.78 2.9 12-3.17 13.22-10.22 41.67-11.63 47.5-1.82 7.68-6.07 9.28-14 5.59-52.3-24.36-85-100.81-85-162.25 0-132.1 95.96-253.43 276.71-253.43 145.29 0 258.18 103.5 258.18 241.88 0 144.34-91.02 260.49-217.31 260.49-42.44 0-82.33-22.05-95.97-48.1 0 0-21 79.96-26.1 99.56-8.82 33.9-46.55 104.13-65.49 136.03A446.16 446.16 0 00512 960c247.04 0 448-200.97 448-448S759.04 64 512 64"></path>
				</svg>
			);
		case "tiktok-icon":
			return (
				<svg
					fill-rule="evenodd"
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="tik-tok"
					width="1em"
					height="1em"
					fill="black"
					aria-hidden="true">
					<path d="M912 224.96C912 162.57 861.42 112 799.04 112H224.96C162.57 112 112 162.57 112 224.96v574.08C112 861.43 162.58 912 224.96 912h574.08C861.42 912 912 861.43 912 799.04zM774.76 460.92c-51.62.57-99.71-15.03-141.94-43.93v202.87a192.3 192.3 0 01-149 187.85c-119.06 27.17-219.86-58.95-232.57-161.83-13.3-102.89 52.32-193.06 152.89-213.29 19.65-4.04 49.2-4.04 64.46-.57v108.66c-4.7-1.15-9.09-2.31-13.71-2.89-39.3-6.94-77.37 12.72-92.98 48.55-15.6 35.84-5.16 77.45 26.63 101.73 26.59 20.8 56.09 23.7 86.14 9.82 30.06-13.29 46.21-37.56 49.68-70.5.58-4.63.54-9.84.54-15.04V222.21c0-10.99.09-10.5 11.07-10.5h86.12c6.36 0 8.67.9 9.25 8.43 4.62 67.04 55.53 124.14 120.84 132.81 6.94 1.16 14.37 1.62 22.58 2.2z"></path>
				</svg>
			);

		case "whatspp-icon":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="#128c7e"
					width="24px"
					height="24px">
					<path d="M20.52 3.48A11.932 11.932 0 0 0 12 0C5.373 0 0 5.373 0 12c0 2.11.55 4.17 1.59 6.01L0 24l6.19-1.58A11.913 11.913 0 0 0 12 24c6.627 0 12-5.373 12-12 0-3.2-1.25-6.21-3.48-8.52zM12 22a9.94 9.94 0 0 1-5.13-1.4l-.37-.23-3.67.94.98-3.59-.24-.38A9.968 9.968 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm5.29-7.71l-1.91-.82c-.25-.1-.52-.04-.71.13l-.55.56c-.18.18-.46.23-.7.13a7.85 7.85 0 0 1-3.57-3.57c-.1-.24-.05-.52.13-.7l.56-.55c.17-.18.23-.46.13-.71l-.82-1.91c-.12-.28-.44-.44-.75-.36a4.73 4.73 0 0 0-1.84 1.1 4.52 4.52 0 0 0-.96 5.28 9.319 9.319 0 0 0 5.26 5.25c.62.27 1.27.41 1.94.41 1.17 0 2.33-.39 3.28-1.13a4.73 4.73 0 0 0 1.1-1.84c.08-.31-.08-.63-.36-.75z" />
				</svg>
			);
		case "linkedin-icon":
			return (
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="linkedin"
					width="1em"
					height="1em"
					fill="#0077B5"
					aria-hidden="true">
					<path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1168.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z"></path>
				</svg>
			);
		case "GBP Accounts":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#1f1f1f">
					<path d="M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z" />
				</svg>
			);
		case "Platform Images":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#1f1f1f">
					<path d="m480-420 240-160-240-160v320Zm28 220h224q-7 26-24 42t-44 20L228-85q-33 5-59.5-15.5T138-154L85-591q-4-33 16-59t53-30l46-6v80l-36 5 54 437 290-36Zm-148-80q-33 0-56.5-23.5T280-360v-440q0-33 23.5-56.5T360-880h440q33 0 56.5 23.5T880-800v440q0 33-23.5 56.5T800-280H360Zm0-80h440v-440H360v440Zm220-220ZM218-164Z" />
				</svg>
			);
		case "upload":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#1f1f1f">
					<path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
				</svg>
			);
		case "apple-right":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#e3e3e3">
					<path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
				</svg>
			);
		case "add-image":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#e3e3e3">
					<path d="M480-480ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h365v60H180v600h600v-365h60v365q0 24-18 42t-42 18H180Zm60-162h480L576-474 449-307l-94-124-115 149Zm453-323v-87h-88v-60h88v-88h60v88h87v60h-87v87h-60Z" />
				</svg>
			);
		case "save-icon":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 0 24 24"
					width="24px"
					fill="#e3e3e3">
					<path
						d="M0 0h24v24H0V0z"
						fill="none"
					/>
					<path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z" />
				</svg>
			);
		case "arrow-back":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#e3e3e3">
					<path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
				</svg>
			);
		case "check-circle":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#e3e3e3">
					<path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
				</svg>
			);
		case "filter-icon":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="40px"
					viewBox="0 -960 960 960"
					width="40px"
					fill="#1f1f1f">
					<path d="M400-240v-66.67h160V-240H400ZM240-446.67v-66.66h480v66.66H240ZM120-653.33V-720h720v66.67H120Z" />
				</svg>
			);
		case "chat-on":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#000000">
					<path d="M240-400h480v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46 45v-525H160v480Zm0 0v-480 480Z" />
				</svg>
			);
		case "chat-off":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#000000">
					<path d="M160-240q-33 0-56.5-23.5T80-320v-447l-53-53 57-57L876-85l-57 57-212-212H160Zm720 45L755-320h45v-480H275l-80-80h605q33 0 56.5 23.5T880-800v605ZM160-320h367l-80-80H240v-80h127l-40-40h-87v-80h7l-87-87v367Zm515-80-80-80h125v80h-45ZM555-520l-80-80h245v80H555ZM435-640l-80-80h365v80H435Zm-91 136Zm171-56Z" />
				</svg>
			);
		case "notification-off":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#000000">
					<path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z" />
				</svg>
			);
		case "filter-off":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#000000">
					<path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-308 198-252H282l198 252Zm0 0Z" />
				</svg>
			);
		case "filter-on":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="24px"
					viewBox="0 -960 960 960"
					width="24px"
					fill="#000000">
					<path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Z" />
				</svg>
			);
		default:
			break;
	}
}
